import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=6f482b6a&scoped=true"
import script from "./SelectableCard.vue?vue&type=script&lang=js"
export * from "./SelectableCard.vue?vue&type=script&lang=js"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=6f482b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f482b6a",
  null
  
)

export default component.exports